export const translations = {
    pt: {
        nav: {
            links: ["Serviços", "Contato"],
            cta: "Agendar horário",
        },
        hero: {
            eyebrow: "Studio de nail design · Ubatuba, SP",
            lines: ["O luxo mora", "nos detalhes", "das suas mãos."],
            paragraph:
                "Manicure, pedicure spa, esmaltação em gel e alongamentos com acabamento de revista. Atendimento exclusivo, com hora marcada e cuidado em cada milímetro.",
            ctaPrimary: "Agendar pelo WhatsApp",
            ctaSecondary: "Ver serviços",
            stats: [
                ["5 anos", "de arte e técnica"],
            ],
            badge: "amada pelas clientes",
            scroll: "role para descobrir",
        },
        marquee: [
            "Esmaltação em Gel",
            "Nail Art Autoral",
            "Alongamento em Fibra",
            "Pedicure Spa",
            "Ubatuba · Litoral Norte",
            "Agendamentos Abertos",
        ],
        manifesto: {
            index: "01",
            eyebrow: "O manifesto",
            titleA: "Unhas não são detalhe.",
            titleB: " São assinatura.",
            chapters: [
                {
                    n: "01",
                    title: "Arte nos detalhes",
                    text: "Cada unha é tratada como uma tela. Curvatura, cutícula, cor e brilho pensados para valorizar as suas mãos — nada é automático, tudo é intencional.",
                },
                {
                    n: "02",
                    title: "Durabilidade impecável",
                    text: "Técnicas atualizadas e materiais premium para um resultado que sobrevive à rotina: semanas de brilho sem descascar, sem lascar, sem decepção.",
                },
                {
                    n: "03",
                    title: "Biossegurança & cuidado",
                    text: "Esterilização em autoclave, descartáveis individuais e ambiente impecável. Beleza só é completa quando vem acompanhada de saúde.",
                },
            ],
        },
        services: {
            index: "01",
            eyebrow: "Menu de rituais",
            titleA: "Serviços &",
            titleB: " investimento",
            side: "Tabela oficial do studio. Toque em um serviço para agendar direto no WhatsApp.",
            categories: [
                {
                    title: "Manicure & Pedicure",
                    note: "O clássico impecável, com cuticulagem precisa e acabamento caprichado.",
                },
                {
                    title: "Aplicação",
                    note: "Alongamentos e banho de gel com estrutura sob medida.",
                },
                {
                    title: "Esmaltação & Adicionais",
                    note: "Cores, brilhos e os detalhes que fazem a diferença.",
                },
                {
                    title: "Manutenção & Remoção",
                    note: "Para manter tudo impecável por muito mais tempo.",
                },
            ],
            footerNote:
                "Valores oficiais · agendamento confirmado com sinal de 50% do serviço",
        },
        colors: {
            eyebrow: "— Inverno 2026",
            titleA: "Cores da",
            titleB: " estação",
            side: "A paleta que está dominando o studio neste inverno. Toque na sua favorita e já garanta no agendamento.",
            cta: "Quero essa cor",
            swatches: [
                { hex: "#722F37", name: "Borgonha" },
                { hex: "#3E2F28", name: "Espresso" },
                { hex: "#C4A277", name: "Champanhe" },
                { hex: "#D9C2AD", name: "Amêndoa" },
                { hex: "#8C1C24", name: "Cereja" },
            ],
            note: "Paleta da estação · novas cores a cada temporada",
        },
        gallery: {
            index: "03",
            eyebrow: "Galeria",
            titleA: "Trabalhos em",
            titleB: " spotlight",
            side: "Uma seleção dos designs mais amados do studio. Passe o cursor para sentir a luz — clique para ampliar.",
            captions: [
                "Nude editorial",
                "Nail art autoral",
                "Brilho espelhado",
                "Alongamento em gel",
                "O studio",
                "Cores da estação",
            ],
            note: "Fotos ilustrativas — em breve, o portfólio real da Yasmim aqui",
        },
        beforeAfter: {
            eyebrow: "— Transformações",
            titleA: "Do antes ao",
            titleB: " depois.",
            paragraph:
                "Arraste o divisor e sinta a diferença de um alongamento bem feito: estrutura, curvatura e brilho que transformam as mãos por inteiro.",
            cta: "Quero a minha transformação",
            before: "Antes",
            after: "Depois",
            note: "Arraste para comparar · imagens ilustrativas",
        },
        insta: {
            eyebrow: "— Direto do Instagram",
            titleA: "Fresquinho",
            titleB: " no feed",
            follow: "Seguir",
            note: "Prévia ilustrativa — em breve conectada ao feed real de",
        },
        about: {
            index: "04",
            eyebrow: "A artista",
            titleA: "Prazer,",
            titleB: " Yasmim.",
            p1: "Nail designer em Ubatuba, apaixonada por transformar o cuidado com as mãos em um ritual de autoestima. Cada atendimento é exclusivo: uma cliente por vez, sem pressa, com técnica apurada e aquele papo que faz a hora voar.",
            p2: "Do clássico impecável à nail art autoral, o compromisso é sempre o mesmo — unhas que duram, encantam e contam um pouco da sua história.",
            highlights: [
                "Materiais esterilizados em autoclave",
                "Esmaltes e géis premium importados",
                "Atendimento com hora marcada, sem espera",
            ],
            badge: "anos de arte",
        },
        careTips: {
            eyebrow: "— Ritual pós-unha",
            titleA: "Cuide delas",
            titleB: " em casa",
            tips: [
                {
                    title: "Hidrate as cutículas",
                    text: "Óleo ou cera nutritiva todos os dias. Cutícula hidratada é o segredo de uma esmaltação que dura semanas.",
                },
                {
                    title: "Unhas não são ferramentas",
                    text: "Nada de abrir lacres e embalagens com elas — e luvas sempre que mexer com produtos de limpeza.",
                },
                {
                    title: "Manutenção em dia",
                    text: "Alongamento e gel pedem retorno entre 15 e 30 dias. Assim suas unhas ficam impecáveis o mês inteiro.",
                },
            ],
        },
        testimonials: {
            index: "05",
            eyebrow: "Depoimentos",
            titleA: "Quem vive o ritual,",
            titleB: " recomenda",
            items: [
                {
                    quote: "Minhas unhas nunca duraram tanto. O cuidado da Yasmim com cada detalhe é surreal — saio do studio me sentindo em uma capa de revista.",
                    name: "Beatriz M.",
                    service: "Esmaltação em Gel",
                },
                {
                    quote: "O alongamento ficou perfeito: natural, resistente e exatamente do jeito que eu sonhei. Atendimento pontual e um carinho que não existe em outro lugar.",
                    name: "Camila R.",
                    service: "Alongamento em Gel",
                },
                {
                    quote: "A nail art é arte de verdade. Ela entende o meu estilo antes mesmo de eu terminar de explicar e sempre entrega além do que eu imagino.",
                    name: "Larissa T.",
                    service: "Nail Art Autoral",
                },
            ],
        },
        faq: {
            index: "02",
            eyebrow: "Dúvidas frequentes",
            titleA: "Perguntas de",
            titleB: " quem ama",
            titleC: " unhas",
            side: "Não achou a sua dúvida? Me chama no WhatsApp que eu respondo pessoalmente — sem robô, sem demora.",
            cta: "Tirar dúvida no WhatsApp",
            items: [
                {
                    q: "Como funciona o agendamento?",
                    a: "É tudo pelo WhatsApp: você escolhe o serviço, combinamos o melhor horário e pronto. O atendimento é sempre com hora marcada — sem fila, sem espera.",
                },
                {
                    q: "Quanto tempo dura a esmaltação em gel?",
                    a: "Com os cuidados certos, de 10 a 15 dias de brilho espelhado e cor intensa, sem descascar e sem precisar esperar secar.",
                },
                {
                    q: "De quanto em quanto tempo faço manutenção do alongamento?",
                    a: "O ideal é retornar entre 15 e 30 dias, conforme o crescimento da sua unha natural. Assim a estrutura continua perfeita e confortável.",
                },
                {
                    q: "Preciso remover o alongamento para fazer a manutenção?",
                    a: "Não! A manutenção preenche a área de crescimento e corrige a estrutura. A remoção só é necessária se você quiser tirar o alongamento de vez.",
                },
                {
                    q: "O material é esterilizado?",
                    a: "Sim. Alicates e instrumentais passam por esterilização em autoclave, e lixas e palitos são descartáveis e individuais.",
                },
                {
                    q: "Quais são as formas de pagamento?",
                    a: "Pix, dinheiro ou cartão (crédito e débito). Para garantir o seu horário, o agendamento é confirmado com um sinal de 50% do valor do serviço — o restante você acerta no dia do atendimento.",
                },
            ],
        },
        contact: {
            index: "03",
            eyebrow: "Contato & localização",
            titleA: "Pronta para a sua próxima",
            titleB: " unha impecável?",
            cta: "Agendar pelo WhatsApp",
            sub: "Resposta rápida · agenda da semana aberta",
            studioTitle: "O studio",
            maps: "Como chegar",
            hoursTitle: "Horários",
            hours1: "Terça a Sábado",
            hours2: "10h às 18h",
            hoursTag: "Atendimento com hora marcada",
            instaTitle: "Instagram",
            instaText: "Bastidores, novidades e os designs mais recentes do studio.",
        },
        footer: {
            tagline:
                "Studio de nail design em Ubatuba. Unhas que duram, encantam e contam a sua história — um detalhe de cada vez.",
            nav: "Navegação",
            contact: "Contato",
            rights: "© 2026 Yasmim Nails · Ubatuba, SP",
            quote: "O luxo mora nos detalhes.",
        },
        share: {
            text: "Yasmim Nails — Studio de nail design em Ubatuba. Agende seu horário!",
            copied: "Link copiado! Envie para uma amiga.",
        },
        credentials: {
            eyebrow: "— Formação & certificações",
            titleA: "Sempre em",
            titleB: " evolução",
            side: "Técnica se aprimora todos os anos. Cada certificado é um compromisso renovado com as suas mãos.",
            items: [
                {
                    year: "2025",
                    title: "Nail Art Autoral & Design Criativo",
                    text: "Aperfeiçoamento em traços finos, encapsuladas e pintura à mão livre.",
                },
                {
                    year: "2024",
                    title: "Alongamento em Fibra & Molde F1",
                    text: "Especialização em estruturas resistentes, leves e com caimento natural.",
                },
                {
                    year: "2023",
                    title: "Esmaltação em Gel Profissional",
                    text: "Formação completa em aplicação, curvatura perfeita e durabilidade estendida.",
                },
                {
                    year: "2022",
                    title: "Biossegurança para Nail Designers",
                    text: "Esterilização em autoclave, descartáveis e protocolos de segurança.",
                },
            ],
            note: "Formação continuada · novos cursos todos os anos",
        },
    },
    en: {
        nav: {
            links: ["Services", "Contact"],
            cta: "Book now",
        },
        hero: {
            eyebrow: "Nail design studio · Ubatuba, Brazil",
            lines: ["Luxury lives", "in the details", "of your hands."],
            paragraph:
                "Manicures, spa pedicures, gel polish and extensions with a magazine-worthy finish. Exclusive, by-appointment care in every millimetre.",
            ctaPrimary: "Book on WhatsApp",
            ctaSecondary: "View services",
            stats: [
                ["5 years", "of art & technique"],
            ],
            badge: "loved by clients",
            scroll: "scroll to explore",
        },
        marquee: [
            "Gel Polish",
            "Signature Nail Art",
            "Fiberglass Extensions",
            "Spa Pedicure",
            "Ubatuba · North Coast",
            "Bookings Open",
        ],
        manifesto: {
            index: "01",
            eyebrow: "The manifesto",
            titleA: "Nails are not a detail.",
            titleB: " They're a signature.",
            chapters: [
                {
                    n: "01",
                    title: "Art in the details",
                    text: "Every nail is treated as a canvas. Shape, cuticles, colour and shine designed to flatter your hands — nothing is automatic, everything is intentional.",
                },
                {
                    n: "02",
                    title: "Flawless durability",
                    text: "Up-to-date techniques and premium materials for results that survive your routine: weeks of shine without chipping, cracking or disappointment.",
                },
                {
                    n: "03",
                    title: "Biosafety & care",
                    text: "Autoclave sterilisation, single-use disposables and a spotless space. Beauty is only complete when it comes with health.",
                },
            ],
        },
        services: {
            index: "01",
            eyebrow: "Ritual menu",
            titleA: "Services &",
            titleB: " investment",
            side: "Official studio price list. Tap a service to book straight on WhatsApp.",
            categories: [
                {
                    title: "Manicure & Pedicure",
                    note: "The flawless classic, with precise cuticle work and a polished finish.",
                },
                {
                    title: "Application",
                    note: "Extensions and gel overlay with a made-to-measure structure.",
                },
                {
                    title: "Polish & Extras",
                    note: "Colours, shine and the details that make the difference.",
                },
                {
                    title: "Maintenance & Removal",
                    note: "To keep everything flawless for much longer.",
                },
            ],
            footerNote:
                "Official prices · booking confirmed with a 50% deposit",
        },
        colors: {
            eyebrow: "— Winter 2026",
            titleA: "Colours of",
            titleB: " the season",
            side: "The palette taking over the studio this winter. Tap your favourite and lock it in when you book.",
            cta: "I want this one",
            swatches: [
                { hex: "#722F37", name: "Burgundy" },
                { hex: "#3E2F28", name: "Espresso" },
                { hex: "#C4A277", name: "Champagne" },
                { hex: "#D9C2AD", name: "Almond" },
                { hex: "#8C1C24", name: "Cherry" },
            ],
            note: "Seasonal palette · new colours every season",
        },
        gallery: {
            index: "03",
            eyebrow: "Gallery",
            titleA: "Work in",
            titleB: " the spotlight",
            side: "A selection of the studio's most loved designs. Hover to feel the light — click to enlarge.",
            captions: [
                "Editorial nude",
                "Signature nail art",
                "Mirror shine",
                "Gel extensions",
                "The studio",
                "Colours of the season",
            ],
            note: "Illustrative photos — Yasmim's real portfolio coming soon",
        },
        beforeAfter: {
            eyebrow: "— Transformations",
            titleA: "From before to",
            titleB: " after.",
            paragraph:
                "Drag the divider and feel the difference of well-crafted extensions: structure, curve and shine that transform the whole hand.",
            cta: "I want my transformation",
            before: "Before",
            after: "After",
            note: "Drag to compare · illustrative images",
        },
        insta: {
            eyebrow: "— Straight from Instagram",
            titleA: "Fresh",
            titleB: " on the feed",
            follow: "Follow",
            note: "Illustrative preview — soon connected to the real feed of",
        },
        about: {
            index: "04",
            eyebrow: "The artist",
            titleA: "Hi, I'm",
            titleB: " Yasmim.",
            p1: "A nail designer in Ubatuba, passionate about turning hand care into a self-esteem ritual. Every appointment is exclusive: one client at a time, no rushing, sharp technique and the kind of chat that makes time fly.",
            p2: "From the flawless classic to signature nail art, the commitment is always the same — nails that last, delight and tell a bit of your story.",
            highlights: [
                "Autoclave-sterilised tools",
                "Premium imported polishes and gels",
                "By appointment only — no waiting",
            ],
            badge: "years of artistry",
        },
        careTips: {
            eyebrow: "— Aftercare ritual",
            titleA: "Care for them",
            titleB: " at home",
            tips: [
                {
                    title: "Moisturise your cuticles",
                    text: "Cuticle oil or nourishing balm every day. Hydrated cuticles are the secret behind polish that lasts for weeks.",
                },
                {
                    title: "Nails aren't tools",
                    text: "No opening seals or packages with them — and gloves on whenever you handle cleaning products.",
                },
                {
                    title: "Maintenance on time",
                    text: "Extensions and gel need a touch-up every 15 to 30 days. That's how your nails stay flawless all month.",
                },
            ],
        },
        testimonials: {
            index: "05",
            eyebrow: "Reviews",
            titleA: "Those who live the ritual,",
            titleB: " recommend it",
            items: [
                {
                    quote: "My nails have never lasted this long. Yasmim's attention to every detail is surreal — I leave the studio feeling like I'm on a magazine cover.",
                    name: "Beatriz M.",
                    service: "Gel Polish",
                },
                {
                    quote: "The extensions turned out perfect: natural, strong and exactly how I dreamed. Punctual service with a warmth you won't find anywhere else.",
                    name: "Camila R.",
                    service: "Gel Extensions",
                },
                {
                    quote: "The nail art is true art. She understands my style before I even finish explaining and always delivers beyond what I imagine.",
                    name: "Larissa T.",
                    service: "Signature Nail Art",
                },
            ],
        },
        faq: {
            index: "02",
            eyebrow: "Frequently asked",
            titleA: "Questions from",
            titleB: " nail",
            titleC: " lovers",
            side: "Didn't find yours? Message me on WhatsApp — I answer personally, no bots, no waiting.",
            cta: "Ask on WhatsApp",
            items: [
                {
                    q: "How does booking work?",
                    a: "Everything happens over WhatsApp: you pick the service, we find the best time and that's it. Always by appointment — no queue, no waiting.",
                },
                {
                    q: "How long does gel polish last?",
                    a: "With the right care, 10 to 15 days of mirror shine and rich colour — no chipping and no drying time.",
                },
                {
                    q: "How often should I book extension maintenance?",
                    a: "Ideally every 15 to 30 days, depending on how fast your natural nails grow. That keeps the structure perfect and comfortable.",
                },
                {
                    q: "Do I need to remove the extensions for maintenance?",
                    a: "No! Maintenance fills the regrowth area and corrects the structure. Removal is only needed if you want them off for good.",
                },
                {
                    q: "Are the tools sterilised?",
                    a: "Yes. Nippers and instruments go through autoclave sterilisation, and files and sticks are single-use and individual.",
                },
                {
                    q: "What payment methods are accepted?",
                    a: "Pix, cash or card (credit and debit). To secure your slot, bookings are confirmed with a 50% deposit — the rest is settled on the day.",
                },
            ],
        },
        contact: {
            index: "03",
            eyebrow: "Contact & location",
            titleA: "Ready for your next",
            titleB: " flawless set?",
            cta: "Book on WhatsApp",
            sub: "Quick reply · this week's schedule open",
            studioTitle: "The studio",
            maps: "Get directions",
            hoursTitle: "Opening hours",
            hours1: "Tuesday to Saturday",
            hours2: "10am – 6pm",
            hoursTag: "By appointment only",
            instaTitle: "Instagram",
            instaText: "Behind the scenes, news and the studio's latest designs.",
        },
        footer: {
            tagline:
                "Nail design studio in Ubatuba. Nails that last, delight and tell your story — one detail at a time.",
            nav: "Navigation",
            contact: "Contact",
            rights: "© 2026 Yasmim Nails · Ubatuba, Brazil",
            quote: "Luxury lives in the details.",
        },
        share: {
            text: "Yasmim Nails — Nail design studio in Ubatuba. Book your appointment!",
            copied: "Link copied! Send it to a friend.",
        },
        credentials: {
            eyebrow: "— Training & certifications",
            titleA: "Always",
            titleB: " evolving",
            side: "Technique is sharpened every year. Each certificate is a renewed commitment to your hands.",
            items: [
                {
                    year: "2025",
                    title: "Signature Nail Art & Creative Design",
                    text: "Advanced training in fine lines, encapsulated art and freehand painting.",
                },
                {
                    year: "2024",
                    title: "Fiberglass & F1 Form Extensions",
                    text: "Specialisation in strong, lightweight structures with a natural fit.",
                },
                {
                    year: "2023",
                    title: "Professional Gel Polish",
                    text: "Full training in application, perfect apex and extended durability.",
                },
                {
                    year: "2022",
                    title: "Biosafety for Nail Designers",
                    text: "Autoclave sterilisation, disposables and safety protocols.",
                },
            ],
            note: "Ongoing education · new courses every year",
        },
    },
};
